export enum LuggageType {
    hold = "hold",
    cabin = "cabin"
}

export enum BookingXType {
    individual = "individual",
    group = "group"
}

export enum BookingType {
    air = "air",
    stay = "stay",
    vehicleRental = "VehicleRental"
}

export enum XChannel {
    extranet = "extranet",
    internet = "internet",
    intranet = "intranet"
}

export enum PriceRateXRole {
    public = "public",
    negotiated = "negotiated"
}

export enum TravellerXTitle {
    mr = "mr",
    ms = "ms",
    mrs = "mrs",
    ch = "ch",
    in = "in"
}

export enum TravellerPrimitiveXType {
    adult = "Adult",
    child = "Child",
    infant = "Infant"}

export enum TravellerXType {
    adult = "adult",
    child = "child",
    infant = "infant",
    unaccompaniedMinor = "unaccompaniedMinor",
    worker = "worker",
    workerChild = "workerChild",
    youth = "youth",
    visitingFriends = "visitingFriends",
    visitingFriendsChild = "visitingFriendsChild",
    visitingFriendsInfant = "visitingFriendsInfant",
    person = "person",
    senior = "senior",
    student = "student",
    companionPrimary = "companionPrimary",
    companionSecondary = "companionSecondary",
    workerInfant = "workerInfant",
}

export enum AbbreviatedTravellerXType {
    ADT = "ADT",
    INF = "INF",
    CHD = "CHD",
}

export enum ERateType {
    Transportation = "Transportation",
    Service = "Service",
    Fee = "Fee"
}

export enum PersonRole {
    customer = 'customer',
    traveller = 'traveller',
    agency = 'agency',
}

export enum TravellerXGender {
    male = "male",
    female = "female",
}

export enum Keyword {
    exchangeable = 'exchangeable',
    refundable = 'refundable',
    nonRefundable = 'nonRefundable',
}

export enum ServiceCategory {
    mealplan = "mealplan",
    luggage = "luggage",
    seat = "seat",
    cabin = "cabin",
    passenger = "passenger",
    ancillary = "ancillary",
    ticket = "ticket",
    payment = "payment",
    penalty = "penalty",
    loyaltyCard = "loyaltyCard",
    animal = "animal",
    group = "group",
    onGround = "onGround",
    accommodation = "accommodation",
    unknown = "unknown",
}

export enum SsrCode {
    AAML = "AAML",
    ABAG = "ABAG",
    ABML = "ABML",
    ACML = "ACML",
    ADMD = "ADMD",
    ADML = "ADML",
    ADPI = "ADPI",
    ADTK = "ADTK",
    AEML = "AEML",
    AFML = "AFML",
    AGML = "AGML",
    AHML = "AHML",
    AIML = "AIML",
    AJML = "AJML",
    AKML = "AKML",
    ALML = "ALML",
    AMML = "AMML",
    ANML = "ANML",
    AOML = "AOML",
    AOXY = "AOXY",
    APML = "APML",
    AQML = "AQML",
    ARML = "ARML",
    ASVC = "ASVC",
    AUPL = "AUPL",
    AVIH = "AVIH",
    AVML = "AVML",
    AWUP = "AWUP",
    BAGA = "BAGA",
    BAGB = "BAGB",
    BAGC = "BAGC",
    BAGP = "BAGP",
    BBAG = "BBAG",
    BBML = "BBML",
    BIKE = "BIKE",
    BLML = "BLML",
    BLND = "BLND",
    BQML = "BQML",
    BRND = "BRND",
    BSCT = "BSCT",
    BULK = "BULK",
    CBAG = "CBAG",
    CBBG = "CBBG",
    CHAM = "CHAM",
    CHLD = "CHLD",
    CHML = "CHML",
    CKBG = "CKBG",
    CKIN = "CKIN",
    CLAS = "CLAS",
    CLID = "CLID",
    CNML = "CNML",
    CODG = "CODG",
    CODP = "CODP",
    CODS = "CODS",
    COUR = "COUR",
    CTCE = "CTCE",
    CTCM = "CTCM",
    CTCR = "CTCR",
    CUPC = "CUPC",
    CUPF = "CUPF",
    DBAG = "DBAG",
    DBML = "DBML",
    DEAF = "DEAF",
    DEAL = "DEAL",
    DEPA = "DEPA",
    DEPU = "DEPU",
    DIVE = "DIVE",
    DOCA = "DOCA",
    DOCB = "DOCB",
    DOCO = "DOCO",
    DOCS = "DOCS",
    DPNA = "DPNA",
    EDML = "EDML",
    EFML = "EFML",
    EKML = "EKML",
    EPAY = "EPAY",
    ESAN = "ESAN",
    EXPC = "EXPC",
    EXST = "EXST",
    EXWH = "EXWH",
    FAST = "FAST",
    FBAG = "FBAG",
    FBML = "FBML",
    FLEX = "FLEX",
    FOID = "FOID",
    FPML = "FPML",
    FQTR = "FQTR",
    FQTS = "FQTS",
    FQTU = "FQTU",
    FQTV = "FQTV",
    FRAG = "FRAG",
    FRAV = "FRAV",
    FSML = "FSML",
    GFML = "GFML",
    GOLF = "GOLF",
    GPST = "GPST",
    GRML = "GRML",
    GRPF = "GRPF",
    GRPS = "GRPS",
    GUAR = "GUAR",
    GVML = "GVML",
    HAML = "HAML",
    HBAG = "HBAG",
    HBML = "HBML",
    HCML = "HCML",
    HDML = "HDML",
    HEML = "HEML",
    HFML = "HFML",
    HGML = "HGML",
    HHML = "HHML",
    HIML = "HIML",
    HJML = "HJML",
    HKML = "HKML",
    HLML = "HLML",
    HMML = "HMML",
    HNML = "HNML",
    HOML = "HOML",
    HPML = "HPML",
    IAML = "IAML",
    IBAG = "IBAG",
    IBML = "IBML",
    ICML = "ICML",
    IDML = "IDML",
    IEML = "IEML",
    IFML = "IFML",
    INFT = "INFT",
    INML = "INML",
    ITML = "ITML",
    IVML = "IVML",
    JPML = "JPML",
    JUST = "JUST",
    KANU = "KANU",
    KCML = "KCML",
    KFML = "KFML",
    KITE = "KITE",
    KSML = "KSML",
    LANG = "LANG",
    LCML = "LCML",
    LFML = "LFML",
    LIMO = "LIMO",
    LOUG = "LOUG",
    LPML = "LPML",
    LSML = "LSML",
    LUGP = "LUGP",
    MAAS = "MAAS",
    MEDA = "MEDA",
    MOML = "MOML",
    MUSI = "MUSI",
    MUSM = "MUSM",
    MUSS = "MUSS",
    NAME = "NAME",
    NFCZ = "NFCZ",
    NFML = "NFML",
    NLML = "NLML",
    NOCM = "NOCM",
    NSSA = "NSSA",
    NSSB = "NSSB",
    NSST = "NSST",
    NSSW = "NSSW",
    NUFE = "NUFE",
    OBML = "OBML",
    ONEW = "ONEW",
    ORML = "ORML",
    OTHS = "OTHS",
    OVSZ = "OVSZ",
    OVWT = "OVWT",
    OXYG = "OXYG",
    PAML = "PAML",
    PCDA = "PCDA",
    PCML = "PCML",
    PCTC = "PCTC",
    PDAC = "PDAC",
    PDAH = "PDAH",
    PDBG = "PDBG",
    PDUP = "PDUP",
    PENF = "PENF",
    PETC = "PETC",
    PNUT = "PNUT",
    PPOC = "PPOC",
    PRML = "PRML",
    PROT = "PROT",
    PSPT = "PSPT",
    PTCZ = "PTCZ",
    PXBG = "PXBG",
    RFML = "RFML",
    RFTV = "RFTV",
    RGML = "RGML",
    RQST = "RQST",
    RSVR = "RSVR",
    RSVT = "RSVT",
    RVML = "RVML",
    SCUB = "SCUB",
    SEAT = "SEAT",
    SEKT = "SEKT",
    SEMN = "SEMN",
    SFML = "SFML",
    SKIS = "SKIS",
    SKML = "SKML",
    SKTP = "SKTP",
    SLPR = "SLPR",
    SMED = "SMED",
    SMSA = "SMSA",
    SMSB = "SMSB",
    SMST = "SMST",
    SMSW = "SMSW",
    SOML = "SOML",
    SPEQ = "SPEQ",
    SPML = "SPML",
    SRVA = "SRVA",
    STCR = "STCR",
    STPD = "STPD",
    STPP = "STPP",
    SURF = "SURF",
    SVAN = "SVAN",
    SXBG = "SXBG",
    TKNA = "TKNA",
    TKNC = "TKNC",
    TKNE = "TKNE",
    TKNM = "TKNM",
    TKTL = "TKTL",
    TRML = "TRML",
    TWOV = "TWOV",
    TXBG = "TXBG",
    UMNR = "UMNR",
    VGML = "VGML",
    VJML = "VJML",
    VLML = "VLML",
    VOML = "VOML",
    WAKE = "WAKE",
    WBAG = "WBAG",
    WCBD = "WCBD",
    WCBW = "WCBW",
    WCHC = "WCHC",
    WCHP = "WCHP",
    WCHR = "WCHR",
    WCHS = "WCHS",
    WCLB = "WCLB",
    WCMP = "WCMP",
    WCOB = "WCOB",
    WEAP = "WEAP",
    WIND = "WIND",
    XBAC = "XBAC",
    XBAG = "XBAG",
    XBGS = "XBGS",
    XLST = "XLST",
    XPCM = "XPCM",
    XSBG = "XSBG",
    XSBP = "XSBP"
}